import Env from "../base/env";
import Channels from "../base/channels";
import Component from "gia/Component";
import gsap from "gsap";
import { enableScroll, disableScroll } from "../common/ScrollDisabler";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
import { ScrollToPlugin } from "../vendor/gsap-bonus-umd/ScrollToPlugin";
import easesCustom from "../fx/CustomEases";
gsap.registerPlugin(ScrollTrigger, SplitText, ScrollToPlugin);
import { calculateMask } from "../fx/Common";
import WheelIndicator from "wheel-indicator";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    //! Options
    this.options = JSON.parse(this.element.getAttribute("data-options"));
    this.options.lineThreshold =
      typeof this.options.lineThreshold != "undefined"
        ? this.options.lineThreshold
        : 0.2;
    this.options.titleSelector =
      typeof this.options.titleSelector != "undefined"
        ? this.options.titleSelector
        : ".fxTitle";
    this.options.titleTranslateY =
      typeof this.options.titleTranslateY != "undefined"
        ? this.options.titleTranslateY
        : 110;
    //! DOM
    this.DOM = {};
    this.DOM.view = this.element;
    this.DOM.title = this.DOM.view.querySelector(this.options.titleSelector);
    this.DOM.titleSvg = this.DOM.view.querySelector(".fxTitleSvg");
    this.DOM.subtitle = this.DOM.view.querySelector(".fxSubtitle");
    this.DOM.cache = this.DOM.view.querySelector(".fxCacheSEO");
    this.DOM.cta = this.DOM.view.querySelector(".fxCta");
    this.DOM.bg = this.DOM.view.querySelectorAll(".fxBg");
    this.DOM.fade = this.DOM.view.querySelector(".fxFade");
    this.DOM.mask = this.DOM.view.querySelector(".fxMask");
    this.DOM.logo = this.DOM.view.querySelector(".fxLogo");
    this.DOM.maskVisuals = this.DOM.view.querySelectorAll(".fxMaskVisual");
    this.DOM.anchorsSummary =
      this.DOM.view.parentElement.querySelector(".anchors-summary");
    //! VARS
    this.TYPE = this.DOM.view.getAttribute("data-type");
    this.FX = {};
    if (this.DOM.title != null) {
      this.FX.titleLines = new SplitText(this.DOM.title, {
        type: "lines",
        linesClass: "lines tw-overflow-hidden",
        lineThreshold: this.options.lineThreshold,
      });
      this.FX.titleChars = new SplitText(this.DOM.title, { type: "chars" });
    }

    this.FX.settings = {
      title: {
        y: {
          from: this.options.titleTranslateY,
        },
      },
    };
    //! Vars
    this.VARS = {};
    this.VARS.DIRECTION = 1;
    this.VARS.CAN_MOVE = false;
    this.VARS.IS_ANCHORING = false;
    this.VARS.TOGGLED_ANCHOR = false;
    //! Fns
    this.fadeScroll();
    if (Env.ios == false) {
      this.makeSticky();
    }
    console.log("coco");

    this.funcLaunch = this._fx.bind(this);
    this.events();

    Channels.on("launcher::exit", this.funcLaunch);
    Channels.on("transition::end", this.funcLaunch);
  }

  events() {
    this.indicator = new WheelIndicator({
      elem: this.DOM.view,
      callback: (e) => {
        this.VARS.DIRECTION = e.direction;
        this.moveToLimit();
      },
    });
    this.indicator.getOption("preventMouse");

    // click on cta
    this.ref.btnScroll[0].addEventListener("click", () => {
      this.VARS.DIRECTION = "down";
      this.moveToLimit();
    });

    //
  }

  _fx() {
    console.log("fx");
    const delay = Env.isVisiting ? 0.3 : 1;
    gsap.delayedCall(delay, () => {
      this.reveal();
    });
  }

  fadeScroll() {
    this.fade = ScrollTrigger.create({
      trigger: document.body,
      start: "top top",
      end: "+=100%",
      invalidateOnRefresh: true,
      onUpdate: (e) => {
        gsap.set(this.DOM.fade, { autoAlpha: e.progress });
      },
    });
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top top",
      pin: true,
      pinSpacing: false,
      // end: () => ScrollTrigger.maxScroll(document.body),
      end: () => {
        const viewport = Env.framework.toolbox.getViewport();
        return `+=${viewport.height}px`;
      },
      invalidateOnRefresh: true,
      onUpdate: () => {
        // console.log(Env.framework.toolbox.scrollPosition().scrollY,Env.framework.toolbox.getViewport().height);
      },
      // onLeave:()=>{
      //   Channels.emit('skin::add::dark')
      // },
      // onEnterBack:()=>{
      //   Channels.emit('skin::remove::dark')
      // }
    });
  }

  moveToLimit() {
    if (this.VARS.IS_ANCHORING == false) {
      if (this.VARS.DIRECTION == "down") {
        Channels.emit("cover::out");
        const viewport = Env.framework.toolbox.getViewport();
        gsap.to(window, {
          scrollTo: viewport.height,
          duration: 0.8,
          ease: easesCustom.quart,
          onStart: () => {
            this.VARS.IS_ANCHORING = true;
          },
          onComplete: () => {
            this.VARS.IS_ANCHORING = false;
          },
        });
      } else {
        Channels.emit("cover::in");
        gsap.to(window, {
          scrollTo: 0,
          duration: 0.8,
          ease: easesCustom.quart,
          onStart: () => {
            this.VARS.IS_ANCHORING = true;
          },
          onComplete: () => {
            this.VARS.IS_ANCHORING = false;
          },
        });
      }
    }
  }

  reveal() {
    const clipFrom = calculateMask(this.DOM.mask, "from", "height");
    const clipTo = calculateMask(this.DOM.mask, "to", "height");
    this.tlReveal = gsap.timeline();
    if (typeof this.FX.titleChars != "undefined") {
      this.tlReveal.add(() => {
        gsap.set(this.FX.titleChars.chars, {
          y: this.FX.settings.title.y.from,
        }),
          gsap.set(this.DOM.mask, { clip: clipFrom });
      });
    }
    console.log("eveal");
    this.tlReveal.add([
      gsap.fromTo(
        this.DOM.cache,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          duration: 2,
          ease: "cubic.out",
        }
      ),
    ]);
    this.tlReveal.add(
      [
        gsap.fromTo(
          this.DOM.bg,
          {
            scale: 1.4,
          },
          {
            scale: 1.01,
            ease: "quad.inOut",
            duration: 2,
          }
        ),
        gsap.fromTo(
          this.DOM.mask,
          {
            clip: clipFrom,
          },
          {
            clip: clipTo,
            ease: "quart.inOut",
            duration: 1.5,
            delay: 0.2,
            onComplete: () => {
              gsap.set(this.DOM.mask, { clearProps: "clip" });
            },
          }
        ),
        gsap.fromTo(
          this.DOM.maskVisuals,
          {
            scale: 1.2,
          },
          {
            scale: 1,
            ease: "quint.inOut",
            duration: 1.2,
            delay: 0.4,
          }
        ),
      ],
      "-=1.2"
    );

    if (typeof this.FX.titleChars != "undefined") {
      this.tlReveal.add(
        [
          gsap.fromTo(
            this.FX.titleChars.chars,
            {
              autoAlpha: 0,
              y: this.FX.settings.title.y.from,
            },
            {
              autoAlpha: 1,
              y: 0,
              ease: easesCustom.quart,
              duration: 1,
              stagger: 0.05,
              immediateRender: false,
              onStart: () => {
                gsap.set(this.ref.titleContainer, { zIndex: 10 });
              },
              onComplete: () => {
                if (this.FX.titleChars.chars[0].parentElement != null) {
                  this.FX.titleChars.chars[0].parentElement.classList.remove(
                    "tw-overflow-hidden"
                  );
                }
              },
            }
          ),
        ],
        "<-.5"
      );
    }

    if (this.DOM.titleSvg != null) {
      this.tlReveal.add(
        [
          gsap.fromTo(
            this.DOM.titleSvg.querySelectorAll("path"),
            {
              y: this.FX.settings.title.y.from,
            },
            {
              y: 0,
              ease: easesCustom.quart,
              duration: 1,
              stagger: 0.1,
              delay: 0.5,
            }
          ),
        ],
        "<"
      );
    }

    if (this.DOM.cta != null) {
      this.tlReveal.add(
        [
          gsap.fromTo(
            this.DOM.cta,
            {
              autoAlpha: 0,
              y: 25,
            },
            {
              immediateRender: true,
              autoAlpha: 1,
              y: 0,
              ease: easesCustom.quart,
              duration: 1,
              delay: 0.8,
            }
          ),
        ],
        "<"
      );
    }

    if (this.DOM.anchorsSummary != null) {
      this.tlReveal.add(
        [
          gsap.fromTo(
            this.DOM.anchorsSummary,
            {
              autoAlpha: 0,
              y: 25,
            },
            {
              immediateRender: true,
              autoAlpha: 1,
              y: 0,
              ease: easesCustom.quart,
              duration: 1,
            }
          ),
        ],
        "<"
      );
    }
  }

  unmount() {
    Channels.removeListener("launcher::exit", this.funcLaunch);
    Channels.removeListener("transition::end", this.funcLaunch);
    this.fade.kill();
    if (typeof this.sticky != "undefined") {
      this.sticky.kill();
    }
    this.indicator.destroy();
  }
}
